import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import {
  Container,
  Row,
  Col,
  Card,
  CardBody
} from "reactstrap";
// core components

function Formato() {

  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    // initialise Rellax for this page
    if (window.innerWidth >= 991) {
      setTimeout(function () {
        new Rellax(".rellax", {
          center: true,
        });
      }, 5000);
      new Rellax(".rellax-header");
      new Rellax(".rellax-text");
    }

    // we need to add a script for the github buttons
    let script = document.createElement("script");
    script.src = "https://buttons.github.io/buttons.js";
    script.id = "github-buttons-script-id";
    document.body.appendChild(script);

    return function cleanup() {
      document.body.classList.remove("tramites-page");
      document.body.classList.remove("sidebar-collapse");

      // we need to remove the script when we change the page
      script.parentNode.removeChild(script);
    };
  });
  return (
    <>
      <div className="wrapper">
        <div id="servicio" style={{ backgroundColor: "#f9f9f9" }}>
          <Container className="fluid">
            <Row className="justify-content-center">
              <Col lg="12">
                <h1 className="text-center title" style={{ color: "#031425" }}>
                  FORMATOS Y FORMULARIOS<br></br>
                </h1>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Card>
                  <CardBody>
                    <Row className="justify-content-center">
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/CESION DERECHOS Y ACCIONES HERENCIALES.doc")} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="Imagen con referencia hacia un icono de un documento de Microsoft Word"
                              width="80px"
                              src={require("assets/img/notarias/word.png")}
                            ></img>
                            <h6>CESION DERECHOS Y ACCIONES HERENCIALES</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/COMPRAVENTA DERECHO DE CUOTA.doc")} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="Imagen con referencia Derecho Cuota"
                              width="80px"
                              src={require("assets/img/notarias/word.png")}
                            ></img>
                            <h6>COMPRAVENTA DERECHO DE CUOTA</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/HIPOTECA ABIERTA SIN LIMITE DE CUANTIA.doc")} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="Imagen con referencia Hipoteca Abierta"
                              width="80px"
                              src={require("assets/img/notarias/word.png")}
                            ></img>
                            <h6>HIPOTECA ABIERTA SIN LIMITE DE CUANTIA</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/VENTA CONTADO.doc")} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="Imagen con referencia Venta contado"
                              width="80px"
                              src={require("assets/img/notarias/word.png")}
                            ></img>
                            <h6>VENTA CONTADO</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/VENTA NUDA CON RESERVA DE USUFRUCTO.doc")} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="Imagen con referencia Venta Nuda Reserva"
                              width="80px"
                              src={require("assets/img/notarias/word.png")}
                            ></img>
                            <h6>VENTA NUDA CON RESERVA DE USUFRUCTO</h6>
                          </a>
                        </center>
                      </Col>
                      <Col md="2">
                        <center>
                          <a href={require("../assets/pdf/VENTA PROPIEDAD HORIZONTAL.doc")} style={{ textDecoration: "none !important" }} target="_black">
                            <img
                              alt="Imagen con referencia Venta Propiedad"
                              width="80px"
                              src={require("assets/img/notarias/word.png")}
                            ></img>
                            <h6>VENTA PROPIEDAD HORIZONTAL</h6>
                          </a>
                        </center>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Formato;